import { z } from 'zod';

import { ContractType } from '@/common/graphql';
import { DATETIME_FORMATS, DateUtils } from '@/common/utils';

export const DemographicReportFilter = z.object({
  yearMonth: z.string().default(DateUtils.formatDate(new Date(), DATETIME_FORMATS.yyyyMM)),
  contractTypes: z.array(z.nativeEnum(ContractType)).catch([]),
  countryIds: z.array(z.string()).catch([]),
  locationIds: z.array(z.string()).catch([]),
  companyIds: z.array(z.string()).catch([]),
  businessUnitIds: z.array(z.string()).catch([]),
  departmentIds: z.array(z.string()).catch([]),
  jobIds: z.array(z.string()).catch([]),
  nationalityIds: z.array(z.string()).catch([]),
});

export type DemographicReportFilterType = z.infer<typeof DemographicReportFilter>;
